<template>
  <el-dialog
    title="合作项目介绍管理"
    :visible="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="1200px"
    :before-close="
      () => {
        handleClose(projectContent);
      }
    "
  >
    <div class="introduce-write">
      <div class="write-row write-content">
        <span class="row-label"><i class="text-red">*</i>合作项目介绍：</span>
        <div class="row-control">
          <QuillEditor
            ref="editorRef"
            :value="projectContent"
            v-model="projectContent"
          />
        </div>
      </div>
      <div class="write-footer">
        <el-button size="small" type="primary" @click="handleView(true)">
          预览
        </el-button>
        <el-button
          class="search-but1"
          size="small"
          @click="handleClose(projectContent)"
        >
          取消
        </el-button>
        <el-button size="small" type="primary" @click="handleSubmit">
          确认
        </el-button>
      </div>
    </div>
    <ApplicationPreview
      v-if="viewFlag"
      :handleClose="handleView"
      :defaultContent="projectContent"
    />
  </el-dialog>
</template>
<script>
import QuillEditor from "@/components/QuillEditor/index.vue";
import {
  getProjectContent,
  setProjectContent,
} from "@/api/organization/index.js";
import ApplicationPreview from "./preview.vue";
export default {
  props: ["handleClose"],
  name: "IntroduceDialog",
  components: { QuillEditor, ApplicationPreview },
  data() {
    return {
      projectContent: "",
      viewFlag: false,
    };
  },
  created() {
    this.getContent();
  },
  methods: {
    async getContent() {
      try {
        const res = await getProjectContent();
        const { code, data = {} } = res;
        if (code === 0) {
          this.projectContent = data.content ?? "";
        }
      } catch (error) {}
    },
    async handleSubmit() {
      if (this.projectContent === "<p><br></p>") {
        return this.$message.error("请输入必填项");
      }
      try {
        const res = await setProjectContent({
          content: this.projectContent,
        });
        const { code } = res;
        if (code === 0) {
          this.$message.success("保存成功");
          this.handleClose(null);
        }
      } catch (error) {}
    },
    handleView(bool) {
      this.viewFlag = bool;
    },
  },
};
</script>
<style lang='scss' scoped>
.text-red {
  color: red;
}
.introduce-write {
  .write-row {
    display: flex;
    margin-bottom: 20px;
    .row-label {
      width: 130px;
      text-align: right;
    }
    .row-control {
      flex: 1;
    }
    .img-control {
      display: flex;
    }
  }
  .write-footer {
    text-align: right;
  }
}
</style>